import { FC, Fragment, useEffect } from 'react'
import { Tiny2 } from '@/components/atoms/typography'
import { Flex } from '@/components/atoms/Grid'
import styled from 'styled-components'
import { SlugPathItem } from 'types/slugPath'
import { useMainNavigationDispatch } from '@/providers/mainNavigationMenuProvider'
import { ArrowIconBreadcrumbnDefault } from '../atoms/icons/ArrowIconBreadcrumb'
import { useProductDetailBack } from 'hooks/useProductDetailBack'

type BreadcrumbDetailMobileProps = {
  paths: SlugPathItem[]
  productId?: string
} & Rest

const BreadcrumbDetailMobile: FC<BreadcrumbDetailMobileProps> = ({
  paths,
  productId,
  ...rest
}) => {
  const { updateSlugPath } = useMainNavigationDispatch()
  const handleBack = useProductDetailBack(paths, productId)

  useEffect(() => {
    updateSlugPath(paths)
    return () => {
      updateSlugPath([])
    }
  }, [paths])

  return (
    <Wrapper {...rest} data-testid="BreadcrumbDetailMobile">
      {paths?.length > 0 && (
        <Content>
          {(() => {
            const lastItem = paths[paths.length - 1]
            return lastItem ? (
              <Fragment key={lastItem.url + lastItem.title}>
                <BackButton onClick={handleBack}>
                  <IconWrapper>
                    <ArrowIconBreadcrumbnDefault></ArrowIconBreadcrumbnDefault>
                  </IconWrapper>

                  <PathItem>{lastItem.title}</PathItem>
                </BackButton>
              </Fragment>
            ) : null
          })()}
        </Content>
      )}
    </Wrapper>
  )
}

export default BreadcrumbDetailMobile

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 15px 0px 10px;
  margin: 5px 0;
  position: relative;
  z-index: 10;
`

const Content = styled(Flex)`
  flex-wrap: wrap;
  align-items: center;
`

const BackButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
`

const PathItem = styled(Tiny2)`
  font-weight: 400;
  margin: 0;
  font-size: 15px;
  opacity: 0.8;
  display: flex;
  align-items: center;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`
